var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.35 13.356a.5.5 0 0 1-.35.144.52.52 0 0 1-.356-.144l-2.7-2.706a5.763 5.763 0 1 1 .706-.706l2.7 2.7a.5.5 0 0 1 0 .712M6.25 11A4.75 4.75 0 1 0 1.5 6.25 4.756 4.756 0 0 0 6.25 11"
})));
export { SvgSearchIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/searchIcon.svg";